/** InsCoder 2026-08-03 B + Customer Support mega menu width calculation **/
(function() {
  var measured = false;
  var maxMeasureAttempts = 10;
  var measureFrame;
  var resizeObserver;

  function measureAndSetWidth() {
    var customerMegas = document.querySelectorAll('.mega-menu--customer');
    if (customerMegas.length === 0) {
      measured = true;
      return;
    }

    var allMeasured = true;
    customerMegas.forEach(function(megaMenu) {
      var inner = megaMenu.querySelector('.mega-menu-customer__inner');
      if (!inner) {
        allMeasured = false;
        return;
      }

      var innerWidth = inner.scrollWidth;
      if (innerWidth === 0 || innerWidth === undefined) {
        allMeasured = false;
        return;
      }

      megaMenu.style.setProperty('--mega-menu--customer-width', innerWidth + 'px');
    });

    if (allMeasured) {
      measured = true;
    }
  }

  /** InsCoder 2026-08-03 B + Pin right-side mega menu to viewport right edge (fixed) **/
  function positionRightMenus() {
    var rightMenus = document.querySelectorAll('.mega-menu--customer.mega-menu--customer-right');
    rightMenus.forEach(function(menu) {
      var headerBottom = menu.closest('.header__bottom');
      if (!headerBottom) return;
      // Menu is position:fixed (relative to viewport). Pin its top to where it would
      // naturally sit below the header bar: offsetParent(.header__bottom) top + 30px.
      var topValue = headerBottom.getBoundingClientRect().top + 30;
      menu.style.setProperty('--mega-menu--customer-top', topValue + 'px');
    });
  }
  /** InsCoder 2026-08-03 E + Pin right-side mega menu to viewport right edge (fixed) **/

  function tryMeasure(attempt) {
    // Mega-menu needs display:flex (from body.header-loaded) to have dimensions
    if (!document.body.classList.contains('header-loaded')) {
      return;
    }

    measureAndSetWidth();
    positionRightMenus();

    // Avoid an unbounded loop while the menu is hidden and has no measurable width.
    if (!measured && attempt < maxMeasureAttempts) {
      requestAnimationFrame(function() {
        tryMeasure(attempt + 1);
      });
    }
  }

  function scheduleMeasure() {
    if (measureFrame) {
      cancelAnimationFrame(measureFrame);
    }

    measureFrame = requestAnimationFrame(function() {
      measureFrame = null;
      tryMeasure(0);
    });
  }

  function observeMenuSizes() {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    resizeObserver = new ResizeObserver(function(entries) {
      if (entries.length === 0) {
        return;
      }

      measured = false;
      scheduleMeasure();
    });

    document.querySelectorAll('.mega-menu--customer .mega-menu-customer__inner').forEach(function(inner) {
      resizeObserver.observe(inner);
    });
  }

  function init() {
    if (document.body.classList.contains('header-loaded')) {
      observeMenuSizes();
      scheduleMeasure();
      return;
    }

    // Wait for header-loaded class via MutationObserver
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (document.body.classList.contains('header-loaded')) {
            observer.disconnect();
            observeMenuSizes();
            scheduleMeasure();
          }
        }
      });
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-position on resize/scroll (sticky header shifts the menu anchor point)
  var repositionTimer;
  function scheduleReposition() {
    clearTimeout(repositionTimer);
    repositionTimer = setTimeout(function() {
      measured = false;
      scheduleMeasure();
    }, 100);
  }
  window.addEventListener('resize', scheduleReposition);
  window.addEventListener('scroll', scheduleReposition, { passive: true });
})();
/** InsCoder 2026-08-03 E + Customer Support mega menu width calculation **/
